<template>
    <div class="formScreen">
        <el-form class="custom-out-form" :model="formScreen" label-width="96px" inline ref="formScreen">
            <el-row>
                <el-col :span="6">
                <el-form-item label="分公司" prop="branchCompanyId">
                    <el-select v-model="formScreen.branchCompanyId" filterable placeholder="请选择" @change="selectChange">
                        <el-option
                            v-for="item in formData.listBranch"
                            :key="item.id"
                            :label="item.companyFullName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                
                <el-col :span="6">
                <el-form-item label="子公司" prop="subCompanyId">
                    <el-select v-model="formScreen.subCompanyId" filterable placeholder="请选择">
                        <el-option
                            v-for="item in formData.listSon"
                            :key="item.id"
                            :label="item.companyFullName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                </el-col>

                <el-col :span="6">
                <el-form-item label="开始日期" prop="startTimeString">
                    <el-date-picker
                        v-model="formScreen.startTimeString"
                        align="right"
                        type="datetime"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                </el-col>

                <el-col :span="6">
                <el-form-item label="结束日期" prop="endTimeString">
                    <el-date-picker
                        v-model="formScreen.endTimeString"
                        align="right"
                        type="datetime"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex">
                <el-col :span="6">
                <el-form-item label="审核状态" prop="checkResult" v-if="pageType !== 'server'">
                    <el-select v-model="formScreen.checkResult" placeholder="请选择">
                        <el-option
                            v-for="item in listExamine"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="处理状态" prop="exceptionResult" v-else>
                  <el-select v-model="formScreen.exceptionResult" placeholder="请选择">
                    <el-option
                        v-for="item in listExamine2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="报错角色" prop="errorRoleId">
                    <el-select v-model="formScreen.errorRoleId" filterable placeholder="请选择">
                        <el-option
                            v-for="item in formData.roleList"
                            :key="item.roleId"
                            :label="item.roleName+'-'+item.userName"
                            :value="item.roleId"
                         ></el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="时间类型筛选" prop="orderType">
                  <el-radio-group v-model="formScreen.orderType">
                    <el-radio :label="0">全部</el-radio>
                    <el-radio :label="1">报错时间</el-radio>
                    <el-radio :label="2">处理时间</el-radio>
                </el-radio-group>
                </el-form-item>
                </el-col>  
            </el-row>
            <el-row type="flex">
                    <el-col :span="12">
                        <div class="box">
                            <el-form-item label=" " prop="searchString">
                                <el-input style="width:70%;" v-model.trim="formScreen.searchString" :placeholder="`订单号、订单ID${placeholder}`"></el-input>
                                <el-button type="primary" @click="queryForm" style="margin-left:10px;">搜索</el-button>
                                <el-button type="primary" @click="resetForm">重置</el-button>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
        </el-form>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
    name: "formScreen",
    props: {
        formData: {
            type: Object,
            default() {
                return {};
            },
        },
        pageType: String,
        placeholder: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            UserInfo:"",
            listExamine: [
                {
                    value: "0",
                    label: "未审核",
                },
                {
                    value: "1",
                    label: "审核通过",
                },
            ],
            listExamine2: [
              { value: 0, label: '未处理' },
              { value: 1, label: '申请退件' },
            //   { value: 2, label: '确认退件' },
              { value: 3, label: '申请转库存' },
            //   { value: 4, label: '确认转库存' },
              { value: 5, label: '申请取消异常' },
            //   { value: 6, label: '确认取消异常' },
            //   { value: 7, label: '已退件' },
              { value: 9, label: '申请转未知' },
            //   { value: 10, label: '确认转未知' },
            ],
            formScreen: {
                branchCompanyId: "",
                subCompanyId: "",
                startTimeString: "",
                endTimeString: "",
                searchString: "",
                checkResult: "",
                orderType:0,
                type: "",
            },
        };
    },
    methods: {
        queryForm(type) {
            this.$emit("confirm", this.formScreen, type,this.companyId);
        },
        resetForm() {
            this.$refs.formScreen.resetFields();
            this.$emit("resetSonCompany");
            this.queryForm("reset");
        },
        getBranchCompanyList() {
            const API = Baseurl + "logisticsController/getAllBranchCompany";
            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.formData.listBranch = data;
                }
            });
        },
        getErrorRoleNameList() {
            ajaxPost(Baseurl + "logisticsController/getErrorRoleNameList").then(res => {
                const { code, data } = res.data;
                if(code == 200){
                    this.formData.roleList = data
                }
            });
        },
        selectChange(id) {
            this.$emit("resetSonCompany");
            this.$emit("formChange", id);
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/ {
    .box .el-form-item{
        width: 100%;
    }
    .box .el-form-item__content {
        width: 88%!important;
    }
}
</style>
<style lang="scss" scoped>
.formScreen {
    .custom-out-form {
        .search-box {
            display: flex;
            align-items: center;
            .el-form-item {
                margin-right: 10px;
            }
        }
    }
}
</style>
